var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFatDude(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 266.849,
    height: 238.474,
    viewBox: "0 0 266.849 238.474",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2168",
    "data-name": "Rectangle 2168",
    width: 266.849,
    height: 209.408,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2163",
    "data-name": "Rectangle 2163",
    width: 399.676,
    height: 430.786,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2165",
    "data-name": "Rectangle 2165",
    width: 0.251,
    height: 0.126,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2166",
    "data-name": "Rectangle 2166",
    width: 83.877,
    height: 29.124,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2589",
    "data-name": "Group 2589",
    transform: "translate(-93.076 -314.423)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2588",
    "data-name": "Group 2588",
    transform: "translate(-56.924 314.423)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2587",
    "data-name": "Group 2587",
    transform: "translate(150)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2586",
    "data-name": "Group 2586",
    transform: "translate(-132.827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2585",
    "data-name": "Group 2585",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2907",
    "data-name": "Path 2907",
    d: "M282.949,165.625H199.072l10.485-54.52h83.877Z",
    transform: "translate(22.366 12.483)",
    fill: "#2e60be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2908",
    "data-name": "Path 2908",
    d: "M174.848,128.681a2.534,2.534,0,0,0,2.488,3.012h91.313a2.534,2.534,0,0,0,2.488-2.056l1.344-6.987H176.008Z",
    transform: "translate(19.639 13.78)",
    fill: "#26c6f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2909",
    "data-name": "Path 2909",
    d: "M279.612,74.406H188.3a2.534,2.534,0,0,0-2.488,2.056l-9.924,51.61h96.473L282.1,77.418a2.534,2.534,0,0,0-2.488-3.012",
    transform: "translate(19.761 8.36)",
    fill: "#cae5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2910",
    "data-name": "Path 2910",
    d: "M214.619,132.532c1.2-3.316,1.944-5.686,1.944-5.686s2.754-14.4-9.514-10.7a20.189,20.189,0,0,0-6.259,9.952c-.622,2.1-1.364,4.342-2.092,6.437Z",
    transform: "translate(22.324 12.981)",
    fill: "#387ab6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2911",
    "data-name": "Path 2911",
    d: "M239.472,133.058c-.226-7.1-.666-12.79-1.433-14.324-2.254-4.131-11.454-7.887-11.454-7.887l-12.581,1.878s-5.258,1.5-6.948,5.257c-.568,1.263-1.942,7.4-3.408,15.076Z",
    transform: "translate(22.88 12.454)",
    fill: "#dce4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2912",
    "data-name": "Path 2912",
    d: "M215.136,103.835a47.917,47.917,0,0,1-2.434,9.734s-.456,3.194,6.236,1.825,5.78-4.715,5.78-4.715V97.447Z",
    transform: "translate(23.897 10.948)",
    fill: "#ff8d68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2913",
    "data-name": "Path 2913",
    d: "M206.445,91.63s.076,12.582,3.686,18.643c2.465,2.549,10.869-1.455,14.4-6.864S228,89.862,225.2,85.331s-12.016-3.168-14.715-1.6-4.2,5.89-4.044,7.9",
    transform: "translate(23.193 9.24)",
    fill: "#ff8d68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2914",
    "data-name": "Path 2914",
    d: "M221.758,97.29s2.373-3.656,3.96-1.479-3.91,6.63-4.33,4.935a6.04,6.04,0,0,1,.37-3.456",
    transform: "translate(24.86 10.687)",
    fill: "#fba894"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2915",
    "data-name": "Path 2915",
    d: "M206.617,91.725s-4.414-3.881.91-8.9c3.041-2.281,4.562-.608,7.756-1.217s8.973,0,11.1,3.346,1.369,11.1.761,11.863-2.434,1.217-2.434,2.585-.3,2.434-.761,2.434-.456-2.281-.456-3.954a26.236,26.236,0,0,0-1.065-7.148c-.761-2.281-4.258-2.13-5.627-1.825s-2.275,3.808-10.187,2.816",
    transform: "translate(23.021 9.145)",
    fill: "#713336"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2581",
    "data-name": "Group 2581",
    transform: "translate(246.211 104.524)",
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2580",
    "data-name": "Group 2580"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2579",
    "data-name": "Group 2579",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2916",
    "data-name": "Path 2916",
    d: "M221.343,94.093s.1-.05.251-.113v-.011Z",
    transform: "translate(-221.343 -93.967)",
    fill: "#505e83"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2917",
    "data-name": "Path 2917",
    d: "M223.044,94c.029.249.825,7.534-2.067,9.564-3,2-3.129-.563-5.508-.939s-4.318-.25-5.383,1.315c-.939,1.565-.751,2.254-1.627,1.815-.187.5,1.127,3.567,3.13,4.382s6.76-1.691,8.888-3.568,3.443-3.067,3.819-4.694.187-4.756.625-6.948c.25-1.654-1.263-1.181-1.877-.927M212.089,107.45c-2.879-.626-2.5-2.879.438-3.818,0,0,3.129-1.44,4.194.751.438,1.439-1.753,3.693-4.632,3.067",
    transform: "translate(23.419 10.532)",
    fill: "#713336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2918",
    "data-name": "Path 2918",
    d: "M224.791,108.485a15.259,15.259,0,0,1-9.671,5.164c-1.22-.469-1.878-2.723-1.878-2.723l-.939,1.409s-.469,2.816,0,3.943c.564.093,2.63-1.315,2.63-1.315s1.408,1.971,2.44,2.347,7.605-4.037,8.263-6.2a5.323,5.323,0,0,0-.845-2.628",
    transform: "translate(23.829 12.189)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2919",
    "data-name": "Path 2919",
    d: "M238.534,133.058c-.327-7-.745-12.345-1.139-13.447-1.5-3.506-7.136-8.012-12.706-8.763,0,0-2.092,9.659-4.151,22.21Z",
    transform: "translate(24.778 12.454)",
    fill: "#387ab6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2920",
    "data-name": "Path 2920",
    d: "M208.207,132.831c2.951-12.523,5.229-19.957,5.229-19.957a13.206,13.206,0,0,0-6.76,3.567c-1.121,2.243-2.863,8.683-4.662,16.389Z",
    transform: "translate(22.697 12.682)",
    fill: "#387ab6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2921",
    "data-name": "Path 2921",
    d: "M237.1,132.476c.2-6.7-.17-12.892-1.265-14.324-3.568-3-7.324-2.816-9.2.563-1.027,1.848-2.388,8.294-3.414,13.761Z",
    transform: "translate(25.08 13.036)",
    fill: "#387ab6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2922",
    "data-name": "Path 2922",
    d: "M214.924,114.309c-1.064,4.336-1.947,8.723-2.744,13.116",
    transform: "translate(23.839 12.843)",
    fill: "none",
    stroke: "#87b8eb",
    strokeMiterlimit: 10,
    strokeWidth: 0.359
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2923",
    "data-name": "Path 2923",
    d: "M287.528,74.023c-2.6,10.426-13.159,18.879-23.585,18.879s-16.771-8.453-14.171-18.879,13.159-18.878,23.585-18.878,16.771,8.452,14.171,18.878",
    transform: "translate(27.997 6.196)",
    fill: "#6787ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2924",
    "data-name": "Path 2924",
    d: "M288.164,90.87a7.059,7.059,0,0,1-6.455,5.167c-2.853,0-4.59-2.314-3.879-5.167a7.059,7.059,0,0,1,6.455-5.167c2.854,0,4.591,2.314,3.879,5.167",
    transform: "translate(31.197 9.629)",
    fill: "#6787ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2925",
    "data-name": "Path 2925",
    d: "M262.984,82.429a1.789,1.789,0,0,1-1.472-.68l-4.879-6.5a2.483,2.483,0,0,1,.819-3.283c1.132-.907,2.6-.907,3.281,0l3.647,4.858L277.41,66.4c1.132-.907,2.6-.907,3.281,0a2.483,2.483,0,0,1-.818,3.283l-15.079,12.07a2.95,2.95,0,0,1-1.811.68",
    transform: "translate(28.795 7.383)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2926",
    "data-name": "Path 2926",
    d: "M142.822,45.017h-6.175a2.121,2.121,0,0,1-2.107-2.806l1.539-6.175a3.834,3.834,0,0,1,3.506-2.806h6.175a2.12,2.12,0,0,1,2.107,2.806l-1.539,6.175a3.833,3.833,0,0,1-3.506,2.806",
    transform: "translate(15.106 3.733)",
    fill: "#bfd9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2927",
    "data-name": "Path 2927",
    d: "M138.764,61.291H132.59a2.12,2.12,0,0,1-2.107-2.806l1.539-6.175a3.833,3.833,0,0,1,3.506-2.806H141.7a2.12,2.12,0,0,1,2.107,2.806l-1.539,6.175A3.834,3.834,0,0,1,138.764,61.291Z",
    transform: "translate(14.65 5.562)",
    fill: "none",
    stroke: "#a9a7e7",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2928",
    "data-name": "Path 2928",
    d: "M156.427,61.291h-6.175a2.12,2.12,0,0,1-2.107-2.806l1.539-6.175a3.833,3.833,0,0,1,3.506-2.806h6.175a2.12,2.12,0,0,1,2.107,2.806l-1.54,6.175a3.834,3.834,0,0,1-3.506,2.806",
    transform: "translate(16.635 5.562)",
    fill: "#26c6da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2929",
    "data-name": "Path 2929",
    d: "M174.089,61.291h-6.175a2.121,2.121,0,0,1-2.107-2.806l1.54-6.175a3.833,3.833,0,0,1,3.506-2.806h6.175a2.12,2.12,0,0,1,2.107,2.806L177.6,58.484a3.833,3.833,0,0,1-3.506,2.806",
    transform: "translate(18.619 5.562)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2930",
    "data-name": "Path 2930",
    d: "M134.612,77.944h-6.175a2.121,2.121,0,0,1-2.107-2.806l1.539-6.175a3.833,3.833,0,0,1,3.506-2.806h6.175a2.12,2.12,0,0,1,2.107,2.806l-1.539,6.175a3.834,3.834,0,0,1-3.506,2.806",
    transform: "translate(14.184 7.433)",
    fill: "#26c6da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2931",
    "data-name": "Path 2931",
    d: "M130.177,95.733H124a2.121,2.121,0,0,1-2.107-2.808l1.54-6.175a3.834,3.834,0,0,1,3.506-2.806h6.175a2.12,2.12,0,0,1,2.107,2.806l-1.539,6.175a3.835,3.835,0,0,1-3.506,2.808",
    transform: "translate(13.686 9.431)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2932",
    "data-name": "Path 2932",
    d: "M152.275,77.944H146.1a2.121,2.121,0,0,1-2.108-2.806l1.539-6.175a3.834,3.834,0,0,1,3.507-2.806h6.175a2.119,2.119,0,0,1,2.106,2.806l-1.54,6.175a3.832,3.832,0,0,1-3.5,2.806",
    transform: "translate(16.168 7.433)",
    fill: "#edf4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2933",
    "data-name": "Path 2933",
    d: "M144.537,108.979h-6.175a2.12,2.12,0,0,1-2.107-2.806L137.8,100a3.833,3.833,0,0,1,3.506-2.806h6.175A2.12,2.12,0,0,1,149.583,100l-1.539,6.175A3.834,3.834,0,0,1,144.537,108.979Z",
    transform: "translate(15.299 10.92)",
    fill: "none",
    stroke: "#a9a7e7",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2934",
    "data-name": "Path 2934",
    d: "M311,86.661h-2.267a.778.778,0,0,1-.773-1.03l.565-2.267a1.407,1.407,0,0,1,1.287-1.03h2.267a.778.778,0,0,1,.773,1.03l-.565,2.267A1.407,1.407,0,0,1,311,86.661",
    transform: "translate(34.596 9.25)",
    fill: "#cae5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2935",
    "data-name": "Path 2935",
    d: "M309.506,92.636h-2.267a.778.778,0,0,1-.773-1.03l.565-2.267a1.406,1.406,0,0,1,1.287-1.03h2.267a.778.778,0,0,1,.773,1.03l-.565,2.267a1.407,1.407,0,0,1-1.287,1.03",
    transform: "translate(34.429 9.922)",
    fill: "#cae5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2936",
    "data-name": "Path 2936",
    d: "M315.99,92.636h-2.267a.778.778,0,0,1-.773-1.03l.565-2.267a1.406,1.406,0,0,1,1.287-1.03h2.267a.778.778,0,0,1,.773,1.03l-.565,2.267a1.407,1.407,0,0,1-1.287,1.03",
    transform: "translate(35.157 9.922)",
    fill: "#cae5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2937",
    "data-name": "Path 2937",
    d: "M322.474,92.636h-2.267a.778.778,0,0,1-.773-1.03L320,89.339a1.406,1.406,0,0,1,1.287-1.03h2.267a.778.778,0,0,1,.773,1.03l-.565,2.267a1.407,1.407,0,0,1-1.287,1.03",
    transform: "translate(35.886 9.922)",
    fill: "#cae5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2938",
    "data-name": "Path 2938",
    d: "M307.982,98.749h-2.267a.778.778,0,0,1-.773-1.03l.565-2.267a1.406,1.406,0,0,1,1.287-1.03h2.267a.778.778,0,0,1,.773,1.03l-.565,2.267a1.407,1.407,0,0,1-1.287,1.03",
    transform: "translate(34.257 10.609)",
    fill: "#cae5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2939",
    "data-name": "Path 2939",
    d: "M306.353,105.279h-2.267a.778.778,0,0,1-.773-1.029l.565-2.267a1.406,1.406,0,0,1,1.287-1.031h2.267a.778.778,0,0,1,.773,1.031l-.565,2.267a1.407,1.407,0,0,1-1.287,1.029",
    transform: "translate(34.074 11.342)",
    fill: "#cae5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2940",
    "data-name": "Path 2940",
    d: "M314.465,98.749H312.2a.778.778,0,0,1-.773-1.03l.565-2.267a1.406,1.406,0,0,1,1.287-1.03h2.267a.778.778,0,0,1,.773,1.03l-.565,2.267a1.407,1.407,0,0,1-1.287,1.03",
    transform: "translate(34.986 10.609)",
    fill: "#cae5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2941",
    "data-name": "Path 2941",
    d: "M311.625,110.142h-2.267a.778.778,0,0,1-.773-1.03l.565-2.267a1.406,1.406,0,0,1,1.287-1.03H312.7a.777.777,0,0,1,.773,1.03l-.565,2.267a1.406,1.406,0,0,1-1.287,1.03",
    transform: "translate(34.667 11.889)",
    fill: "#cae5ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2584",
    "data-name": "Group 2584",
    transform: "translate(269.142 152.675)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2583",
    "data-name": "Group 2583"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2582",
    "data-name": "Group 2582",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2942",
    "data-name": "Path 2942",
    d: "M317.681,166.378H243.156a1.2,1.2,0,0,1-1.159-1.5l6.957-26.73a1.2,1.2,0,0,1,1.158-.9h74.525a1.2,1.2,0,0,1,1.159,1.5l-6.958,26.73a1.2,1.2,0,0,1-1.157.9",
    transform: "translate(-241.958 -137.254)",
    fill: "#bfd9ff"
  })))), /*#__PURE__*/React.createElement("line", {
    id: "Line_131",
    "data-name": "Line 131",
    x2: 25.932,
    transform: "translate(280.561 158.393)",
    fill: "none",
    stroke: "#a9c2ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.076
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_132",
    "data-name": "Line 132",
    x2: 25.932,
    transform: "translate(278.566 170.362)",
    fill: "none",
    stroke: "#a9c2ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.076
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_133",
    "data-name": "Line 133",
    x2: 25.932,
    transform: "translate(289.471 165.84)",
    fill: "none",
    stroke: "#a9c2ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.076
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_134",
    "data-name": "Line 134",
    x2: 7.78,
    transform: "translate(279.896 162.382)",
    fill: "none",
    stroke: "#a9c2ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.076
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_135",
    "data-name": "Line 135",
    x2: 7.78,
    transform: "translate(278.832 165.84)",
    fill: "none",
    stroke: "#a9c2ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.076
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_136",
    "data-name": "Line 136",
    x2: 9.243,
    transform: "translate(310.616 158.393)",
    fill: "none",
    stroke: "#a9c2ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.076
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2943",
    "data-name": "Path 2943",
    d: "M284.719,158.463h-13.8a.106.106,0,0,1-.1-.133l.617-2.373a.107.107,0,0,1,.1-.08h13.8a.107.107,0,0,1,.1.133l-.618,2.374A.1.1,0,0,1,284.719,158.463Z",
    transform: "translate(30.426 17.513)",
    fill: "none",
    stroke: "#84aee5",
    strokeMiterlimit: 10,
    strokeWidth: 0.359
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2944",
    "data-name": "Path 2944",
    d: "M269.3,158.463h-13.8a.106.106,0,0,1-.1-.133l.617-2.373a.107.107,0,0,1,.1-.08h13.8a.107.107,0,0,1,.1.133l-.618,2.374A.106.106,0,0,1,269.3,158.463Z",
    transform: "translate(28.693 17.513)",
    fill: "none",
    stroke: "#84aee5",
    strokeMiterlimit: 10,
    strokeWidth: 0.359
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2945",
    "data-name": "Path 2945",
    d: "M307,156.591c-.707-.942-3.577-1.627-4.37-2.57a2.983,2.983,0,0,1-.308-2.137,2.923,2.923,0,0,0,.656-.528,12.7,12.7,0,0,0,.776-1.368.45.45,0,0,0,.33.138c.376-.012,1.811-1.964,1.44-2.417-.211-.258-.553-.034-.806.206.379-.87.646-1.536.646-1.536h-.014c.037-.109.07-.22.1-.331a3.123,3.123,0,0,0-3.1-4.134,5.647,5.647,0,0,0-5.164,4.134c-.028.111-.049.222-.068.331H297.1s-.066.666-.119,1.536c-.135-.24-.364-.464-.705-.206-.6.453-.135,2.4.237,2.417a.729.729,0,0,0,.4-.138,8.319,8.319,0,0,0,.093,1.368,1.662,1.662,0,0,0,.528.649,4.637,4.637,0,0,1-1.328,2.017c-1.263.942-4.475,1.627-5.652,2.57-1.059.848-2,3.323-2.182,3.812h18.912c.065-.489.354-2.964-.283-3.812",
    transform: "translate(32.399 15.944)",
    fill: "#387ab6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2946",
    "data-name": "Path 2946",
    d: "M226.133,156.83H164.98c-5.368,0-8.635-4.353-7.3-9.721s6.776-9.721,12.145-9.721h61.153c5.368,0,8.635,4.353,7.3,9.721s-6.776,9.721-12.145,9.721",
    transform: "translate(17.682 15.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2947",
    "data-name": "Path 2947",
    d: "M170.386,149.149l-2.622,1.219c-.247.115-.456-.071-.354-.314l1.086-2.582a.262.262,0,0,0-.019-.264l-1.42-1.828c-.133-.172.039-.472.291-.507l2.686-.377a.414.414,0,0,0,.265-.162l1.744-2.349c.165-.22.479-.22.534,0l.574,2.349a.212.212,0,0,0,.182.162l2.5.377c.235.036.258.335.038.507l-2.33,1.828a.381.381,0,0,0-.151.264l-.2,2.582a.377.377,0,0,1-.509.314l-2.014-1.219a.3.3,0,0,0-.277,0",
    transform: "translate(18.764 15.934)",
    fill: "#ffa402"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2948",
    "data-name": "Path 2948",
    d: "M181.993,149.149l-2.622,1.219c-.247.115-.456-.071-.354-.314l1.087-2.582a.262.262,0,0,0-.02-.264l-1.419-1.828c-.135-.172.038-.472.29-.507l2.686-.377a.414.414,0,0,0,.265-.162l1.744-2.349c.165-.22.479-.22.534,0l.573,2.349a.216.216,0,0,0,.184.162l2.5.377c.235.036.258.335.039.507l-2.331,1.828a.381.381,0,0,0-.151.264l-.2,2.582a.377.377,0,0,1-.509.314l-2.014-1.219a.3.3,0,0,0-.277,0",
    transform: "translate(20.068 15.934)",
    fill: "#ffa402"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2949",
    "data-name": "Path 2949",
    d: "M193.6,149.149l-2.622,1.219c-.247.115-.456-.071-.354-.314l1.087-2.582a.262.262,0,0,0-.02-.264l-1.42-1.828c-.133-.172.039-.472.291-.507l2.686-.377a.414.414,0,0,0,.265-.162l1.744-2.349c.165-.22.479-.22.534,0l.574,2.349a.212.212,0,0,0,.182.162l2.5.377c.235.036.258.335.039.507l-2.332,1.828a.385.385,0,0,0-.151.264l-.2,2.582a.377.377,0,0,1-.509.314l-2.014-1.219a.3.3,0,0,0-.277,0",
    transform: "translate(21.372 15.934)",
    fill: "#ffa402"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2950",
    "data-name": "Path 2950",
    d: "M205.207,149.149l-2.622,1.219c-.247.115-.456-.071-.354-.314l1.087-2.582a.262.262,0,0,0-.02-.264l-1.42-1.828c-.133-.172.039-.472.293-.507l2.685-.377a.414.414,0,0,0,.265-.162l1.744-2.349c.165-.22.479-.22.534,0l.574,2.349a.212.212,0,0,0,.182.162l2.5.377c.235.036.258.335.039.507l-2.331,1.828a.385.385,0,0,0-.151.264l-.2,2.582a.377.377,0,0,1-.509.314l-2.014-1.219a.3.3,0,0,0-.277,0",
    transform: "translate(22.676 15.934)",
    fill: "#ffa402"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2951",
    "data-name": "Path 2951",
    d: "M216.814,149.149l-2.622,1.219c-.247.115-.456-.071-.354-.314l1.087-2.582a.262.262,0,0,0-.02-.264l-1.419-1.828c-.135-.172.038-.472.29-.507l2.686-.377a.414.414,0,0,0,.265-.162l1.744-2.349c.165-.22.479-.22.534,0l.574,2.349a.212.212,0,0,0,.182.162l2.5.377c.235.036.258.335.039.507l-2.332,1.828a.385.385,0,0,0-.151.264l-.2,2.582a.377.377,0,0,1-.509.314l-2.014-1.219a.3.3,0,0,0-.277,0",
    transform: "translate(23.98 15.934)",
    fill: "#c2d4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2952",
    "data-name": "Path 2952",
    d: "M356.325,125.934H307.36a4.11,4.11,0,0,1-4.059-4.751l.37-2.347a4.109,4.109,0,0,1,4.06-3.469H356.7a4.11,4.11,0,0,1,4.06,4.751l-.37,2.347a4.111,4.111,0,0,1-4.06,3.469",
    transform: "translate(34.071 12.962)",
    fill: "#cae5ff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_137",
    "data-name": "Line 137",
    x2: 42.269,
    transform: "translate(343.481 133.705)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2953",
    "data-name": "Path 2953",
    d: "M193.408,70.2H180.06c-6.348,0-12.588,5.146-13.938,11.494s2.7,11.5,9.051,11.5h2.9a10.662,10.662,0,0,0,10.885,6.674,14.729,14.729,0,0,1-1.744-6.674h1.309c6.348,0,12.588-5.147,13.938-11.5s-2.7-11.494-9.051-11.494",
    transform: "translate(18.635 7.887)",
    fill: "#ff634d"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_138",
    "data-name": "Line 138",
    x2: 12.606,
    transform: "translate(193.017 87.357)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_139",
    "data-name": "Line 139",
    x2: 20.486,
    transform: "translate(191.953 92.363)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2957",
    "data-name": "Path 2957",
    d: "M1.64-14.32H4.68L8.8-3.46h.12l4.12-10.86h3.04V0H13.86V-8.02l.12-2.58h-.12L9.76,0H7.96L3.86-10.6H3.74l.12,2.58V0H1.64ZM21.5.32a4.324,4.324,0,0,1-1.96-.43A3.21,3.21,0,0,1,18.2-1.33a3.378,3.378,0,0,1-.48-1.79,2.991,2.991,0,0,1,1.19-2.5,4.776,4.776,0,0,1,3.01-.92,7.068,7.068,0,0,1,1.62.17A5.866,5.866,0,0,1,24.68-6v-.52a1.907,1.907,0,0,0-.7-1.53,2.7,2.7,0,0,0-1.8-.59,3.282,3.282,0,0,0-1.47.34,2.883,2.883,0,0,0-1.11.94L18.06-8.54A4.591,4.591,0,0,1,19.82-10a5.46,5.46,0,0,1,2.4-.52,4.911,4.911,0,0,1,3.42,1.09,3.936,3.936,0,0,1,1.2,3.07V0H24.68V-1.22h-.1a3.451,3.451,0,0,1-1.24,1.1A3.756,3.756,0,0,1,21.5.32Zm.38-1.82a2.767,2.767,0,0,0,1.44-.38,2.719,2.719,0,0,0,1-1.02,2.769,2.769,0,0,0,.36-1.38,4.477,4.477,0,0,0-1.07-.42,4.985,4.985,0,0,0-1.27-.16,2.788,2.788,0,0,0-1.82.49,1.585,1.585,0,0,0-.58,1.27,1.431,1.431,0,0,0,.54,1.15A2.114,2.114,0,0,0,21.88-1.5ZM32.82.16a3.689,3.689,0,0,1-1.28-.22,2.81,2.81,0,0,1-.98-.58,3.162,3.162,0,0,1-.86-2.34V-8.26H27.92V-10.2H29.7v-2.88h2.2v2.88h2.48v1.94H31.9v4.8a1.676,1.676,0,0,0,.32,1.16,1.22,1.22,0,0,0,1.04.4,1.832,1.832,0,0,0,.6-.09,2.506,2.506,0,0,0,.56-.29V-.14A3.851,3.851,0,0,1,32.82.16ZM40.4.32a5.352,5.352,0,0,1-2.73-.7,4.892,4.892,0,0,1-1.88-1.93,5.737,5.737,0,0,1-.67-2.79,5.737,5.737,0,0,1,.67-2.79,4.892,4.892,0,0,1,1.88-1.93,5.352,5.352,0,0,1,2.73-.7,5.171,5.171,0,0,1,2.86.76A4.178,4.178,0,0,1,44.94-7.7l-2.02.84a2.548,2.548,0,0,0-2.58-1.62,2.85,2.85,0,0,0-1.51.42,3.017,3.017,0,0,0-1.1,1.19,3.709,3.709,0,0,0-.41,1.77,3.768,3.768,0,0,0,.41,1.78,3,3,0,0,0,1.1,1.2,2.85,2.85,0,0,0,1.51.42,3.057,3.057,0,0,0,1.65-.43,2.723,2.723,0,0,0,1.05-1.23l1.98.86A4.65,4.65,0,0,1,43.26-.44,5.171,5.171,0,0,1,40.4.32Zm6.1-14.64h2.2v3.9l-.1,1.56h.1a3.356,3.356,0,0,1,1.31-1.19,3.874,3.874,0,0,1,1.87-.47,3.622,3.622,0,0,1,2.84,1.09,4.279,4.279,0,0,1,.98,2.97V0H53.5V-6.16a2.293,2.293,0,0,0-.61-1.74,2.212,2.212,0,0,0-1.59-.58,2.238,2.238,0,0,0-1.33.42,2.917,2.917,0,0,0-.93,1.11,3.282,3.282,0,0,0-.34,1.47V0H46.5ZM62.06-7.14h6.58v1.88H62.06Zm11.2-7.18h2.46l3.2,9.46.5,1.62h.12l.52-1.62,3.36-9.46h2.44L80.66,0H78.32ZM89.24.32a4.324,4.324,0,0,1-1.96-.43,3.21,3.21,0,0,1-1.34-1.22,3.378,3.378,0,0,1-.48-1.79,2.991,2.991,0,0,1,1.19-2.5,4.776,4.776,0,0,1,3.01-.92,7.068,7.068,0,0,1,1.62.17A5.866,5.866,0,0,1,92.42-6v-.52a1.907,1.907,0,0,0-.7-1.53,2.7,2.7,0,0,0-1.8-.59,3.282,3.282,0,0,0-1.47.34,2.883,2.883,0,0,0-1.11.94L85.8-8.54A4.591,4.591,0,0,1,87.56-10a5.46,5.46,0,0,1,2.4-.52,4.911,4.911,0,0,1,3.42,1.09,3.936,3.936,0,0,1,1.2,3.07V0H92.42V-1.22h-.1a3.451,3.451,0,0,1-1.24,1.1A3.756,3.756,0,0,1,89.24.32Zm.38-1.82a2.767,2.767,0,0,0,1.44-.38,2.719,2.719,0,0,0,1-1.02,2.769,2.769,0,0,0,.36-1.38,4.477,4.477,0,0,0-1.07-.42,4.985,4.985,0,0,0-1.27-.16,2.788,2.788,0,0,0-1.82.49,1.585,1.585,0,0,0-.58,1.27,1.431,1.431,0,0,0,.54,1.15A2.114,2.114,0,0,0,89.62-1.5Zm6.96-12.82h2.2V0h-2.2Zm5.64,2.64a1.428,1.428,0,0,1-1.05-.43,1.428,1.428,0,0,1-.43-1.05,1.428,1.428,0,0,1,.43-1.05,1.428,1.428,0,0,1,1.05-.43,1.428,1.428,0,0,1,1.05.43,1.428,1.428,0,0,1,.43,1.05,1.428,1.428,0,0,1-.43,1.05A1.428,1.428,0,0,1,102.22-11.68Zm-1.1,1.48h2.2V0h-2.2ZM109.92.32a4.621,4.621,0,0,1-2.5-.7,4.953,4.953,0,0,1-1.77-1.93A5.88,5.88,0,0,1,105-5.1a5.88,5.88,0,0,1,.65-2.79,4.953,4.953,0,0,1,1.77-1.93,4.621,4.621,0,0,1,2.5-.7,3.912,3.912,0,0,1,1.94.48,3.51,3.51,0,0,1,1.3,1.18h.1l-.1-1.44v-4.02h2.2V0h-2.1V-1.32h-.1a3.584,3.584,0,0,1-1.3,1.16A3.912,3.912,0,0,1,109.92.32Zm.32-2.02a2.815,2.815,0,0,0,1.49-.42,3.072,3.072,0,0,0,1.11-1.2,3.7,3.7,0,0,0,.42-1.78,3.637,3.637,0,0,0-.42-1.77,3.089,3.089,0,0,0-1.11-1.19,2.815,2.815,0,0,0-1.49-.42,2.866,2.866,0,0,0-1.5.42,3.063,3.063,0,0,0-1.12,1.19,3.637,3.637,0,0,0-.42,1.77,3.7,3.7,0,0,0,.42,1.78,3.047,3.047,0,0,0,1.12,1.2A2.866,2.866,0,0,0,110.24-1.7ZM120.62.32a4.324,4.324,0,0,1-1.96-.43,3.21,3.21,0,0,1-1.34-1.22,3.378,3.378,0,0,1-.48-1.79,2.991,2.991,0,0,1,1.19-2.5,4.776,4.776,0,0,1,3.01-.92,7.068,7.068,0,0,1,1.62.17A5.866,5.866,0,0,1,123.8-6v-.52a1.907,1.907,0,0,0-.7-1.53,2.7,2.7,0,0,0-1.8-.59,3.282,3.282,0,0,0-1.47.34,2.883,2.883,0,0,0-1.11.94l-1.54-1.18A4.591,4.591,0,0,1,118.94-10a5.46,5.46,0,0,1,2.4-.52,4.911,4.911,0,0,1,3.42,1.09,3.936,3.936,0,0,1,1.2,3.07V0H123.8V-1.22h-.1a3.451,3.451,0,0,1-1.24,1.1A3.756,3.756,0,0,1,120.62.32ZM121-1.5a2.767,2.767,0,0,0,1.44-.38,2.719,2.719,0,0,0,1-1.02,2.769,2.769,0,0,0,.36-1.38,4.477,4.477,0,0,0-1.07-.42,4.985,4.985,0,0,0-1.27-.16,2.788,2.788,0,0,0-1.82.49,1.585,1.585,0,0,0-.58,1.27,1.431,1.431,0,0,0,.54,1.15A2.114,2.114,0,0,0,121-1.5ZM131.94.16a3.689,3.689,0,0,1-1.28-.22,2.81,2.81,0,0,1-.98-.58,3.162,3.162,0,0,1-.86-2.34V-8.26h-1.78V-10.2h1.78v-2.88h2.2v2.88h2.48v1.94h-2.48v4.8a1.676,1.676,0,0,0,.32,1.16,1.22,1.22,0,0,0,1.04.4,1.832,1.832,0,0,0,.6-.09,2.506,2.506,0,0,0,.56-.29V-.14A3.851,3.851,0,0,1,131.94.16Zm7.52.16a5.205,5.205,0,0,1-2.69-.7,4.933,4.933,0,0,1-1.86-1.93,5.7,5.7,0,0,1-.67-2.77,5.787,5.787,0,0,1,.65-2.71,5.112,5.112,0,0,1,1.81-1.99,4.8,4.8,0,0,1,2.64-.74,5.08,5.08,0,0,1,2.67.68,4.453,4.453,0,0,1,1.72,1.86,5.866,5.866,0,0,1,.59,2.66,5.113,5.113,0,0,1-.06.7h-7.82a3.107,3.107,0,0,0,1.01,2.19,3.067,3.067,0,0,0,2.07.77,3.019,3.019,0,0,0,1.63-.43,3.229,3.229,0,0,0,1.11-1.17l1.86.88A5.48,5.48,0,0,1,142.24-.4,5.167,5.167,0,0,1,139.46.32Zm2.62-6.62a2.542,2.542,0,0,0-.34-1.07,2.433,2.433,0,0,0-.91-.89,2.885,2.885,0,0,0-1.49-.36,2.644,2.644,0,0,0-1.79.63,3.266,3.266,0,0,0-1.01,1.69Zm8.1-.84h6.58v1.88h-6.58Zm13.36-7.18h2.24v5.94h6.64v-5.94h2.22V0h-2.22V-6.26h-6.64V0h-2.24Zm14.88,2.64a1.428,1.428,0,0,1-1.05-.43,1.428,1.428,0,0,1-.43-1.05,1.428,1.428,0,0,1,.43-1.05,1.428,1.428,0,0,1,1.05-.43,1.428,1.428,0,0,1,1.05.43,1.428,1.428,0,0,1,.43,1.05,1.428,1.428,0,0,1-.43,1.05A1.428,1.428,0,0,1,178.42-11.68Zm-1.1,1.48h2.2V0h-2.2Zm4.54,0h2.1v1.5h.1a2.838,2.838,0,0,1,1.18-1.29,3.375,3.375,0,0,1,1.78-.51,3.355,3.355,0,0,1,1.24.2v2.28a4.685,4.685,0,0,0-1.58-.32,2.349,2.349,0,0,0-1.35.4,2.792,2.792,0,0,0-.93,1.07,3.2,3.2,0,0,0-.34,1.47V0h-2.2ZM193.6.32a5.205,5.205,0,0,1-2.69-.7,4.933,4.933,0,0,1-1.86-1.93,5.7,5.7,0,0,1-.67-2.77,5.787,5.787,0,0,1,.65-2.71,5.112,5.112,0,0,1,1.81-1.99,4.8,4.8,0,0,1,2.64-.74,5.08,5.08,0,0,1,2.67.68,4.453,4.453,0,0,1,1.72,1.86,5.866,5.866,0,0,1,.59,2.66,5.113,5.113,0,0,1-.06.7h-7.82a3.107,3.107,0,0,0,1.01,2.19,3.067,3.067,0,0,0,2.07.77,3.019,3.019,0,0,0,1.63-.43,3.229,3.229,0,0,0,1.11-1.17l1.86.88A5.48,5.48,0,0,1,196.38-.4,5.167,5.167,0,0,1,193.6.32Zm2.62-6.62a2.542,2.542,0,0,0-.34-1.07,2.433,2.433,0,0,0-.91-.89,2.885,2.885,0,0,0-1.49-.36,2.644,2.644,0,0,0-1.79.63,3.266,3.266,0,0,0-1.01,1.69Z",
    transform: "translate(127 552.577)",
    fill: "#474747"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFatDude);
export default __webpack_public_path__ + "static/media/fat-dude.aabba181e88f0006ef711cb031857ed8.svg";
export { ForwardRef as ReactComponent };